import { Routes, Route } from 'react-router-dom';

import { AppLayout, AuthLayout } from '../layouts';

import { LoginPage } from './auth/LoginPage';
import { MfaPage } from './auth/MfaPage';
import { PasswordResetRequestPage } from './auth/PasswordResetRequestPage';
import { PasswordResetConfirmPage } from './auth/PasswordResetConfirmPage';
import { NotFoundPage } from './NotFoundPage';
import {
  ClientDashboardPage,
  ApprovalsListPage,
  ApprovalDetailPage,
  ClientChatPage,
  AccountPage,
  RepLeadsPage,
  RepLeadDetailPage,
} from './portal';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/mfa" element={<MfaPage />} />
        <Route path="/auth/password-reset" element={<PasswordResetRequestPage />} />
        <Route path="/auth/password-reset/confirm" element={<PasswordResetConfirmPage />} />
      </Route>
      <Route element={<AppLayout />}>
        {/* COM client portal (§S1–S4). No documents/billing/dsar destinations — billing folds into the Dashboard. */}
        <Route path="/" element={<ClientDashboardPage />} />
        <Route path="/approvals" element={<ApprovalsListPage />} />
        <Route path="/approvals/:campaignId" element={<ApprovalDetailPage />} />
        <Route path="/chat" element={<ClientChatPage />} />
        <Route path="/profile" element={<AccountPage />} />
        {/* COM rep surface (§S5). The shell route-away guard keeps these rep-only. */}
        <Route path="/leads" element={<RepLeadsPage />} />
        <Route path="/leads/:taskId" element={<RepLeadDetailPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
